import React from "react";
import styles from './styles.module.scss';
import { Input } from "../input";
import { FileUpload } from "../file-upload";
import { Loading } from "../loading";
import { sendCareersFormData } from "../../request-service";
import { useTurnstile } from "../../hooks/useTurnstile";

export function CareersForm() {
    const defaultFormData = {
        desiredPosition: '', workExperience: '', skills: '',
        salary: '', portfolio: '', files: [],
        name: '', email: '', cityOfResidence: ''
    };

    const [formData, setFormData] = React.useState(defaultFormData);
    const [loading, setLoading] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const { turnstileToken, turnstileRef, isCaptchaConfigured, resetTurnstile } = useTurnstile();

    async function handleFormSubmit(event) {
        event.preventDefault();

        if (!turnstileToken) {
            setErrorMessage('Please complete the captcha.');
            return;
        }

        setLoading(true);
        setErrorMessage('');

        const uploadFormData = new FormData();
        const { files, ...restFormData } = formData;

        for (const key in restFormData) {
            if (restFormData.hasOwnProperty(key)) {
                uploadFormData.append(key, restFormData[key]);
            }
        }

        if (files) {
            files.forEach((file) => uploadFormData.append('file', file));
        }

        uploadFormData.append('formType', 'careers');
        uploadFormData.append('turnstileToken', turnstileToken);

        try {
            await sendCareersFormData(uploadFormData);
            setFormData(defaultFormData);
            setLoading(false);
            setSuccessMessage('Your career data was successfully sent.');
            resetTurnstile();
        } catch (error) {
            setLoading(false);
            setErrorMessage(error?.message || 'Something went wrong, please try again later');
            resetTurnstile();
        }
    }

    function getFileExtension(name) {
        const parts = name.split('.');
        return parts.length > 0 ? parts[parts.length - 1] : '';
    }

    function filterFiles(files) {
        const validExt = ['pdf', 'odt', 'ppt', 'pptx', 'key', 'doc', 'docx', 'rtf', 'wpd', 'apk'];
        return Array.from(files).filter(f => validExt.includes(getFileExtension(f.name)));
    }

    function handleFormChange({ target }) {
        let value = target.value;
        if (target.files) {
            value = formData.files;
            Array.prototype.push.apply(value, filterFiles(target.files));
            value = value.slice(0, 3);
        }
        setFormData({ ...formData, [target.name]: value });
    }

    function handleFileUploadFileRemove(file) {
        const copy = [...formData.files];
        const idx = copy.indexOf(file);
        if (idx > -1) { copy.splice(idx, 1); setFormData({ ...formData, files: copy }); }
    }

    function handleMessageClose() { setErrorMessage(''); setSuccessMessage(''); }

    return (
        <div className={styles.publishing}>
            <Loading isLoading={loading} errorMessage={errorMessage} successMessage={successMessage} onMessageClose={handleMessageClose} />
            <form onSubmit={handleFormSubmit} onChange={handleFormChange}>
                <div>
                    <Input label="Desired position" value={formData.desiredPosition} name="desiredPosition" id="desiredPosition" />
                    <Input label="Work experience" value={formData.workExperience} name="workExperience" id="workExperience" />
                    <Input label="Skills" value={formData.skills} name="skills" id="skills" />
                    <Input label="Salary" hint="USD/hr" value={formData.salary} name="salary" id="salary" isRequired={false} />
                    <Input label="Portfolio" value={formData.portfolio} name="portfolio" id="portfolio" isTextarea />
                    <div className={styles.formTextBlock}>
                        <p>Upload files: pdf, odt, ppt, pptx, key, doc, docx, rtf, wpd, apk. Up to 3 files.</p>
                    </div>
                    <FileUpload name='files' files={formData.files} onFileRemove={handleFileUploadFileRemove} />
                </div>
                <div className={styles.rightForm}>
                    <h2 className={styles.formH2}>Contact Details</h2>
                    <Input label="Name" value={formData.name} name="name" id="name" />
                    <Input label="Email" value={formData.email} name="email" id="email" type="email" />
                    <Input label="City of residence" value={formData.cityOfResidence} name="cityOfResidence" id="cityOfResidence" />
                </div>
                <div className={styles.bottom}>
                    <div style={{ marginBottom: '16px' }}>
                        {isCaptchaConfigured ? <div ref={turnstileRef} /> : <div style={{color:'red'}}>Captcha configuration error.</div>}
                    </div>
                    <div className="formSubmitButtonErrorsWrap contactFormButton">
                        <input type="submit" className="buttonWrap button button-green contactSubmitButton" value="Send Message" />
                    </div>
                </div>
            </form>
        </div>
    );
}